/* @flow */
import { Container } from 'flux/utils';
import React from 'react';

import CurrentUser from 'auth/CurrentUser';
import UniversalComposeButton from 'chat/components/UniversalComposeButton.jsx';

class UniversalComposeButtonContainer extends React.Component {
  static getStores() {
    return [CurrentUser];
  }

  static calculateState() {
    return {
      currentUser: CurrentUser.getUser(),
    };
  }

  render() {
    return (
      <UniversalComposeButton {...this.props} {...this.state} />
    );
  }
}

export default Container.create(UniversalComposeButtonContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/chat/containers/UniversalComposeButtonContainer.jsx